import React, { useState } from "react";
import { FilterButtonGroup } from "../filter-button-group";
import { Checkbox } from "antd";
import filterStyles from "../filter.css";

export type CheckboxValueType = number | string | boolean;
export type CheckboxFilterOption = {
  label: React.ReactNode;
  value: CheckboxValueType;
};
export type CheckboxFilterProps = {
  className?: string;
  options: CheckboxFilterOption[];
  defaultValue?: CheckboxValueType[];
  onApplyFilter: (value: CheckboxValueType[]) => void;
  onClearFilter: () => void;
};

const {
  ["filter-dropdown"]: filterDropdownClassName,
  ["filter-content"]: filterContentClassName,
  ["checkbox-group"]: checkboxGroupClassName,
} = filterStyles;

export const CheckboxFilter = ({
  options,
  defaultValue,
  onApplyFilter,
  onClearFilter,
}: CheckboxFilterProps) => {
  const [canApply, setCanApply] = useState(false);
  const [value, setValue] = useState(defaultValue || []);

  const onClickApply = () => {
    setCanApply(false);
    onApplyFilter && onApplyFilter(value);
  };

  const onClickClear = () => {
    setValue([]);
    setCanApply(false);
    onClearFilter && onClearFilter();
  };

  const onChange = (newValue: CheckboxValueType[]) => {
    setValue(newValue);
    setCanApply(true);
  };

  return (
    <div className={filterDropdownClassName}>
      <FilterButtonGroup
        canApply={canApply}
        canClear={value?.length > 0}
        onClickApply={onClickApply}
        onClickClear={onClickClear}
      />
      <div className={filterContentClassName}>
        <Checkbox.Group
          className={checkboxGroupClassName}
          options={options}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
